export const FILTER_VALUES = 'filterValues';
export const SORT_ORDER = 'sortOrder';